import { featureHighlights } from '@/mocks/homeData';
import { useInView } from '@/hooks/useInView';

function FeatureCard({ feature, delay }: { feature: typeof featureHighlights[0]; delay: number }) {
  const [ref, inView] = useInView<HTMLDivElement>();

  return (
    <div
      ref={ref}
      className={`flex items-start gap-4 p-5 rounded-xl transition-all duration-700 hover:bg-background-100 ${
        inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      <div className="w-12 h-12 md:w-14 md:h-14 flex-shrink-0 flex items-center justify-center rounded-xl bg-primary-100/80 text-primary-600">
        <i className={`${feature.icon} text-xl md:text-2xl`} />
      </div>
      <div>
        <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-1">
          {feature.title}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed">
          {feature.description}
        </p>
      </div>
    </div>
  );
}

export default function FeaturesRow() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-10 md:py-14 bg-background-50">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {featureHighlights.map((feature, i) => (
          <FeatureCard key={feature.id} feature={feature} delay={i * 100} />
        ))}
      </div>
    </section>
  );
}